import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Config } from "src/app/utility/config";

@Injectable({
  providedIn: "root",
})
export class SocialmediaService {
  constructor(private http: HttpClient, private config: Config) {}

  GetAll(): Observable<any> {
    const url = this.config.APIUrl + "Holiday/GetAllHoliday?Login_Key=debug1";
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  SaveMedia(data): Observable<any> {
    const url =
      this.config.APIUrl +
      "Holiday/SaveUpdate?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  GetById(Id): Observable<any> {
    const url =
      this.config.APIUrl +
      "Holiday/GetById?Id=" +
      Id +
      "&Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
  DeleteById(Id): Observable<any> {
    const url =
      this.config.APIUrl +
      "Holiday/DeleteHoliday?id=" +
      Id +
      "&Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  // Department
  SaveDepartment(data): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "Department/SaveUpdate?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  GetAllDepartment(): Observable<any> {
    const url =
      this.config.APIUrl +
      "Department/GetAll?Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  GetDepertmentById(Id): Observable<any> {
    const url =
      this.config.APIUrl +
      "Department/GetById?Id=" +
      Id +
      "&Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  DeleteDepartmentById(id): Observable<any> {
    const url =
      this.config.APIUrl +
      "Department/DeleteDepartment?id=" +
      id +
      "&Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
}
